import type { RpcTransport } from "./types";

/**
 * Transport using a MessagePort (from MessageChannel, worker, etc.)
 * This is the preferred transport - private channel, no origin checks needed.
 */
export class MessagePortTransport implements RpcTransport {
  constructor(private port: MessagePort) {
    // Ensure port is started (required for MessagePort to receive messages)
    this.port.start();
  }

  send(message: unknown): void {
    this.port.postMessage(message);
  }

  onMessage(handler: (message: unknown) => void): void {
    this.port.addEventListener("message", (event: MessageEvent) => {
      handler(event.data);
    });
  }

  close(): void {
    this.port.close();
  }
}
